module.exports = __webpack_public_path__ + "img/9fcde807aeb72ac1d1c96f7ce24a82de.png";